module.exports = __webpack_public_path__ + "static/media/Ryan Hakhyeon Cho Resume with Cover Letter.501ca03d.pdf";